import React from 'react';

const PerformanceDashboard = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Performance Dashboard</h1>
      <p>Performance monitoring dashboard coming soon...</p>
    </div>
  );
};

export default PerformanceDashboard;
